
export default {
  props: {
    mask: { type: String, default: null },
    selected: { type: Boolean, default: false },
    negative: { type: Boolean, default: false },
  }
}
